import "./NotificationToast.css";
import { markNotificationAsReadAPI, getAllNotificationsAPI } from "../../utils/api";
import { useDispatch } from "react-redux";
import { setNotificationCount } from "../../store/slices/countState";
import { setChatUser } from "../../store/slices/chatState";

// Global navigation function - will be set by App component
let globalNavigate = null;

export const setGlobalNavigate = (navigate) => {
    globalNavigate = navigate;
};

const NotificationToast = ({ payload }) => {
    const dispatch = useDispatch();

    let notification = payload?.notification;
    if (payload?.data?.notification && typeof payload.data.notification === 'string') {
        try {
            notification = JSON.parse(payload.data.notification);
        } catch (error) {
            console.log("Error parsing notification data:", error);
        }
    }

    const handleRedirecting = () => {
        if (payload?.data?.order_id) {
            if (globalNavigate) {
                globalNavigate(`/order-details/${payload.data.order_id}`);
            } else {
                window.location.href = `/order-details/${payload.data.order_id}`;
            }
        } else if (payload?.data?.ticket_id) {
            if (globalNavigate) {
                globalNavigate(`/support-chat?ticket_id=${payload.data.ticket_id}`);
            } else {
                window.location.href = `/support-chat?ticket_id=${payload.data.ticket_id}`;
            }
        } else if(payload?.data?.user) {
            const userData = typeof payload?.data?.user === 'string'
            ? JSON.parse(payload?.data?.user)
            : payload?.data?.user;
            console.log('userData-=-=-=-=-=-=-=-==-=-=-', userData);
            dispatch(setChatUser(userData));
            if (globalNavigate) {
                globalNavigate("/chat-conversation");
            } else {
                // Store user data in localStorage as backup
                localStorage.setItem('pendingChatUser', JSON.stringify(userData));
                window.location.href = "/chat-conversation";
            }
        }
        else {
            if (globalNavigate) {
                globalNavigate("/notifications");
            } else {
                window.location.href = "/notifications";
            }
        }
    }

    const handleNotificationClick = async () => {
        try {
            if (notification?._id) {
                await markNotificationAsReadAPI({ notification_id: notification._id });
                const response = await getAllNotificationsAPI();
                if (response?.status === 200 && response?.data) {
                    const unreadCount = response.data.filter(notification => notification?.read === 0).length;
                    dispatch(setNotificationCount(unreadCount));
                }
            }

            handleRedirecting();
        } catch (error) {
            console.log("Error handling notification click:", error);
            handleRedirecting();
        }
    };

    return (
        <div id="notificationToast" onClick={handleNotificationClick} style={{ cursor: 'pointer' }}>
            <div id="notificationHeader">
                <div id="titleContainer">
                    <span>{notification?.title}</span>
                </div>
            </div>
            <div id="notificationBody">{notification?.body}</div>
            <div id="progressBar">
                <div id="progressFill"></div>
            </div>
        </div>
    );
};

export default NotificationToast;